import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { Handler } from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { chain, LoadRealTimePrices } from "@SupplyLand/Overrides/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { ViewItem } from "@SupplyLand/Utilities/customTracking";

type Parameter = {
    path: string;
    styledOption?: string;
};
type Props = {
    product?: ProductModel;
    productInfosById?: SafeDictionary<ProductInfo>;
    variantChildren?: ProductModel[];
    variantChildrenProductInfos?: ProductInfo[];
    variantSelection?: SafeDictionary<string>;
    pricingLoaded?: true;
    inventoryLoaded?: true;
};

type HandlerType = Handler<Parameter, Props>;

export const TrackViewProduct: HandlerType = props => {
    ViewItem(props.product);
};
addToChainAfter(chain, LoadRealTimePrices, TrackViewProduct);
